import { render, staticRenderFns } from "./Category-List.vue?vue&type=template&id=949f952a"
import script from "./Category-List.vue?vue&type=script&lang=js"
export * from "./Category-List.vue?vue&type=script&lang=js"
import style0 from "./Category-List.vue?vue&type=style&index=0&id=949f952a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports